import "core-js/modules/es.array.includes.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mg-ui-drop-panel-wrapper"
};
import { nextTick, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
export default {
  __name: 'mg-drop-panel',
  props: /*@__PURE__*/_mergeModels({
    trigger: {
      type: String,
      default: '',
      validator: val => ['', 'hover', 'click'].includes(val)
    },
    placement: {
      type: String,
      default: '',
      validator: val => ['', 'bottom-right', 'bottom-left', 'top-left', 'top-right'].includes(val)
    },
    popClass: {
      type: [String, Object, Array],
      default: ''
    }
  }, {
    "open": {
      default: false
    },
    "openModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['outside-click'], ["update:open"]),
  setup(__props, {
    emit: __emit
  }) {
    const TriggerTypes = Object.freeze({
      Default: '',
      Click: 'click',
      Hover: 'hover'
    });
    const emit = __emit;
    const props = __props;
    const open = _useModel(__props, 'open');
    const holderRef = ref();
    const panelRef = ref();
    const sizeObserverRef = ref();
    const outsizeClickListenerRef = ref();
    const state = reactive({
      rect: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: 0,
        height: 0
      },
      hoverTimer: 0
    });
    const popPos = reactive({
      left: `${state.rect.left.toFixed(0)}px`,
      top: `${state.rect.top.toFixed(0)}px`,
      right: `${state.rect.right.toFixed(0)}px`,
      bottom: `${state.rect.bottom.toFixed(0)}px`
    });
    const events = reactive({
      handleHolderMouseenter() {
        if (state.hoverTimer) {
          clearTimeout(state.hoverTimer);
          state.hoverTimer = 0;
        }
        if (props.trigger === TriggerTypes.Hover) {
          open.value = true;
        }
      },
      handleHolderMouseleave() {
        if (props.trigger === TriggerTypes.Hover) {
          state.hoverTimer = setTimeout(() => {
            open.value = false;
          }, 300);
        }
      },
      handleHolderClick() {
        if (props.trigger === TriggerTypes.Default || props.trigger === TriggerTypes.Click) {
          open.value = !open.value;
        }
      },
      'handlePopPanelMouseenter'() {
        if (props.trigger === TriggerTypes.Hover) {
          if (state.hoverTimer) {
            clearTimeout(state.hoverTimer);
            state.hoverTimer = 0;
          }
          open.value = true;
        }
      },
      'handlePopPanelMouseleave'() {
        state.hoverTimer = setTimeout(() => {
          open.value = false;
        }, 200);
      },
      'handlePopPanelClick'() {
        open.value = false;
      }
    });
    const updateDropdownPosition = () => {
      if (!holderRef.value) return;
      state.rect = holderRef.value.getBoundingClientRect();
      Object.assign(popPos, {
        left: `${state.rect.left.toFixed(0)}px`,
        top: `${state.rect.top.toFixed(0)}px`,
        right: `${state.rect.right.toFixed(0)}px`,
        bottom: `${state.rect.bottom.toFixed(0)}px`
      });
    };
    const initSizeChangeObserver = () => {
      if (holderRef.value) {
        updateDropdownPosition();
        const sizeObserver = new ResizeObserver(() => {
          updateDropdownPosition();
        });
        sizeObserver.observe(holderRef.value);
        sizeObserverRef.value = sizeObserver;
      }
    };
    const freeSizeChangeObserver = () => {
      if (sizeObserverRef.value) {
        sizeObserverRef.value.disconnect();
        sizeObserverRef.value = null;
      }
    };
    const doOutsideClickEvent = e => {
      open.value = false;
      emit('outside-click', e);
    };
    const initEventListener = () => {
      outsizeClickListenerRef.value = e => {
        if (!(!!panelRef.value && panelRef.value.contains(e.target) || !!holderRef.value && holderRef.value.contains(e.target))) {
          nextTick(() => {
            doOutsideClickEvent(e);
          });
        }
      };
      document.body.addEventListener('mousedown', outsizeClickListenerRef.value);
    };
    const freeEventListener = () => {
      if (outsizeClickListenerRef.value) {
        document.body.removeEventListener('mousedown', outsizeClickListenerRef.value);
        outsizeClickListenerRef.value = null;
      }
    };
    onMounted(() => {
      nextTick(() => {
        initSizeChangeObserver();
      });
    });
    watch(() => open.value, val => {
      if (val) {
        initEventListener();
      } else {
        freeEventListener();
      }
    }, {
      immediate: true
    });
    watch(() => open.value, async val => {
      if (val) {
        await nextTick();
        updateDropdownPosition();
      }
    }, {
      immediate: true
    });
    onUnmounted(() => {
      freeSizeChangeObserver();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "holderRef",
        ref: holderRef,
        class: _normalizeClass(['mg-ui-drop-panel-holder', {
          'is--hover': open.value
        }]),
        onMouseenter: _cache[0] || (_cache[0] = (...args) => events.handleHolderMouseenter && events.handleHolderMouseenter(...args)),
        onMouseleave: _cache[1] || (_cache[1] = (...args) => events.handleHolderMouseleave && events.handleHolderMouseleave(...args)),
        onClick: _cache[2] || (_cache[2] = (...args) => events.handleHolderClick && events.handleHolderClick(...args))
      }, [_renderSlot(_ctx.$slots, "default", {
        isOpen: open.value
      })], 34), (_openBlock(), _createBlock(_Teleport, {
        to: "#app"
      }, [_createElementVNode("div", {
        ref_key: "panelRef",
        ref: panelRef,
        class: _normalizeClass(['mg-ui-drop-panel-panel-wrapper', {
          'is--show': open.value
        }, {
          'placement--top-left': __props.placement === 'top-left',
          'placement--top-right': __props.placement === 'top-right',
          'placement--bottom-left': __props.placement === 'bottom-left' || __props.placement === '',
          'placement--bottom-right': __props.placement === 'bottom-right'
        }, ...__props.popClass]),
        style: _normalizeStyle({
          '--mg-ui-drop-panel-pos-l': popPos.left,
          '--mg-ui-drop-panel-pos-t': popPos.top,
          '--mg-ui-drop-panel-pos-r': popPos.right,
          '--mg-ui-drop-panel-pos-b': popPos.bottom
        })
      }, [_createElementVNode("div", {
        class: "mg-ui-drop-panel-panel",
        onMouseenter: _cache[3] || (_cache[3] = (...args) => events.handlePopPanelMouseenter && events.handlePopPanelMouseenter(...args)),
        onMouseleave: _cache[4] || (_cache[4] = (...args) => events.handlePopPanelMouseleave && events.handlePopPanelMouseleave(...args)),
        onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => events.handlePopPanelClick && events.handlePopPanelClick(...args), ["stop"]))
      }, [_renderSlot(_ctx.$slots, "pop-panel", {
        isOpen: open.value
      })], 32)], 6)]))]);
    };
  }
};